import React from 'react';
import { ACTIVE_ADMISSION_STATUSES, ADMISSION_STATUS_COLORS } from '../../constants/admissionStatus';

export default function OpenStatusFunnel({ openByStatus = {} }) {
    const entries = ACTIVE_ADMISSION_STATUSES.map((s) => [s, openByStatus[s] || 0]);
    const max = Math.max(1, ...entries.map(([, n]) => n));
    return (
        <section className="dashboard-section">
            <h3>Open by status</h3>
            <div className="dashboard-bar-list">
                {entries.map(([status, n]) => (
                    <div key={status} className="dashboard-bar">
                        <div
                            className="dashboard-bar-fill"
                            style={{
                                width: `${(n / max) * 100}%`,
                                background: ADMISSION_STATUS_COLORS[status] || '#3b82f6',
                            }}
                        />
                        <span className="dashboard-bar-label">{status} · {n}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
